import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Auth.css";
import { API_BASE_URL } from "../config";

function Auth() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state
  const navigate = useNavigate();

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true); // Show loading animation
    try {
      const url = isLogin
        ? `${API_BASE_URL}/api/user/login`
        : `${API_BASE_URL}/api/user/signup`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Authentication failed");
      }
      if (isLogin) {
        // Store token and username in localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", data.username);
        navigate("/landing"); // Redirect to landing page after login
      } else {
        alert("Signup successful! Redirecting to login.");
        setIsLogin(true);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false); // Hide loading animation when done (success or error)
    }
  };

  return (
    <div className="auth-container">
      <h2>{isLogin ? "Login" : "Sign Up"}</h2>
      {loading ? (
        <div className="loading-spinner"></div> // Show loading animation
      ) : (
        <form onSubmit={handleAuth}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading} // Disable inputs while loading
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading} // Disable inputs while loading
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" disabled={loading}>
            {isLogin ? "Login" : "Sign Up"}
          </button>
        </form>
      )}
      {!loading && ( // Only show toggle link when not loading
        <p onClick={() => setIsLogin(!isLogin)}>
          {isLogin ? "Need an account? Sign up" : "Already have an account? Login"}
        </p>
      )}
    </div>
  );
}

export default Auth;